import { render, staticRenderFns } from "./FormDrawer.vue?vue&type=template&id=14fdd522&scoped=true"
import script from "./FormDrawer.vue?vue&type=script&lang=js"
export * from "./FormDrawer.vue?vue&type=script&lang=js"
import style0 from "./FormDrawer.vue?vue&type=style&index=0&id=14fdd522&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fdd522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fdd522')) {
      api.createRecord('14fdd522', component.options)
    } else {
      api.reload('14fdd522', component.options)
    }
    module.hot.accept("./FormDrawer.vue?vue&type=template&id=14fdd522&scoped=true", function () {
      api.rerender('14fdd522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/FormDrawer.vue"
export default component.exports